<template lang="pug">
  .stepper-bottom(v-if="getCurrentRouteName !== 'init'")
    //- Footer nav -------------------------------------------------------------
    .footer-nav.text-center(:class="nextBtnParams.class")
      UiButton(
        v-if="prevBtnShow"
        v-bind="prevBtnParams"
        @ui-btn-click="prevBtnClick"
      )
      UiButton(
        v-bind="nextBtnParams"
        @ui-btn-click="nextBtnClick"
      )
      .info(v-if="getCurrentRouteName === 'portfolio'")
        p(v-text="notRecommendation")
    //- Footer status ----------------------------------------------------------
    ul.footer-status
      li.no-select(
        v-for="(num, idx) in getStepsCount"
        :class="{'active': idx === getCurrentStepIdx, 'complete': idx < getCurrentStepIdx}"
        v-text="idx === getCurrentStepIdx ? num: ''"
        :key="idx"
      )
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { _cfg } from '@/config'

export default {
  name: 'TheStepperBottom',
  // Data ----------------------------------------------------------------------
  data () {
    return {
      notRecommendation: '*Не является индивидуальной инвестиционной рекомендацией.',
      debouncerNext: null
    }
  },
  // Computed ------------------------------------------------------------------
  computed: {
    // Vuex map getters of the Wizard SM
    ...mapGetters('moduleWizard', [
      'getStepsCount',
      'getCurrentStepIdx',
      'getCurrentStepName',
      'getCurrentRouteName',
      'isCurrentRoute',
      'isWizardMode',
      'getNextStepIdx',
      'getPrevStepIdx',
      'getNextStepName',
      'getPrevStepName',
      'getCurrentViewVm',
      'getNavFields'
    ]),
    // Prev button text
    prevBtnText () {
      return 'Вернуться'
    },
    // Prev btn disable
    prevBtnDisabled () {
      const routes = ['initials', 'portfolio']
      if (this.getNavFields.disablePrev) return true
      if (routes.indexOf(this.getCurrentRouteName) !== -1) return true
      return false
    },
    // Prev button params
    prevBtnParams () {
      return {
        text: this.prevBtnText,
        buttonStyle: 'simple',
        isDisabled: this.prevBtnDisabled
      }
    },
    // Prev button show
    prevBtnShow () {
      if (this.getCurrentRouteName === 'init') return false
      if (this.getCurrentRouteName === 'portfolio') return false
      if (this.getCurrentRouteName === 'user-agreements') return false
      if (this.getCurrentRouteName === 'terms-of-use') return false
      if (this.getCurrentRouteName === 'privacy-policy') return false
      return true
    },
    // Next button text
    nextBtnText () {
      const brand = this.$store.state.config.branded
      const { errorTextNext } = this.getNavFields
      if (errorTextNext.length > 0) return errorTextNext
      if (['user-agreements', 'terms-of-use', 'privacy-policy'].indexOf(this.getCurrentRouteName) !== -1) return 'Вернуться к текущему шагу'
      if (this.getCurrentStepName === 'portfolio') {
        if (brand === 'bbg') return 'Переход в BBG-ADVISOR TERMINAL'
        return ['anderida', 'ds', 'scapital'].indexOf(brand) > -1 ? 'Получить персональную инвестиционную рекомендацию' : 'Переход в CONOMY Terminal®'
      }
      return 'Продолжить'
    },
    // Next btn disable
    nextBtnDisabled () {
      if (['user-agreements', 'terms-of-use', 'privacy-policy'].indexOf(this.getCurrentRouteName) !== -1) return false
      return this.getNavFields.disableNext
    },
    // Next btn params
    nextBtnParams () {
      const brand = this.$store.state.config.branded
      const isPortfolio = this.getCurrentRouteName === 'portfolio'
      return {
        text: this.nextBtnText,
        isLoading: this.getNavFields.loadingNext,
        isDisabled: this.nextBtnDisabled,
        class: {
          'portfolio-step': isPortfolio,
          'anderida-special': isPortfolio && brand === 'anderida',
          'ds-special': isPortfolio && brand === 'ds',
          'scapital-special': isPortfolio && brand === 'scapital'
        },
        ...(isPortfolio && {
          _href: this.getRedirectLinkByBrand(brand),
          _title: brand === 'bbg'
            ? 'Переход в BBG-ADVISOR TERMINAL'
            : ['anderida', 'ds', 'scapital'].indexOf(brand) > -1
              ? 'Получить персональную инвестиционную рекомендацию'
              : 'Переход в CONOMY Terminal®'
        })
      }
    }

  },
  // Watch ---------------------------------------------------------------------
  watch: {
    'getNavFields.errorTextNext': {
      handler (v) {
        if (v.length === 0) return
        if (this.debouncerNext !== null) clearTimeout(this.debouncerNext)
        this.debouncerNext = setTimeout(() => {
          this.SET_NAV_FIELD({ f: 'errorTextNext', v: '' })
          this.debouncerNext = null
        }, 2500)
      }
    }
  },
  // Methods -------------------------------------------------------------------
  methods: {
    // Vuex map mutations of the Wizard SM
    ...mapMutations('moduleWizard', [
      'UNLOCK_STEP_SWITCH',
      'SET_NAV_FIELD'
    ]),
    // Get redirect link by brand
    getRedirectLinkByBrand (brand) {
      if (brand === 'anderida') return 'https://anderida.rg.ht/sign-in/'
      if (brand === 'redcircule') return 'https://circule.rg.ht/sign-in/'
      if (brand === 'vinvestor') return _cfg.security.redirectLink
      if (brand === 'ds') return 'https://ds.rg.ht/sign-in/'
      if (brand === 'scapital') return 'https://scapital.rg.ht/sign-in/'
      if (brand === 'bbg') return 'https://bbg.advisor.rg.ht/'
      return _cfg.security.redirectLink
    },
    // Prev button click
    async prevBtnClick () {
      if (await this.getCurrentViewVm.backSelf()) {
        this.UNLOCK_STEP_SWITCH()
        this.$router.push({ name: this.getPrevStepName }).catch(e => {})
      }
    },
    // Next button click
    async nextBtnClick () {
      if (await this.getCurrentViewVm.nextSelf()) {
        this.UNLOCK_STEP_SWITCH()
        this.$router.push({ name: this.getNextStepName }).catch(e => {})
      }
    }
  }
}
</script>
